<template>
  <div class="fan-top-three" :class="`size-${size}`">
    <div
      class="user-item"
      :data-rank="`rank-${index + 1}`"
      v-for="(item, index) in items"
      :key="index"
    >
      <div class="user-info">
        <div
          class="user-img"
          :style="{ 'background-image': `url(${item?.avatarUrl || defaultAvatar})` }"
        ></div>
        <div class="info-box">
          <div class="rank">
            <div class="label-box">
              <span class="label-shadow">NO.{{ index + 1 }}</span>
              <span class="label-text">NO.{{ index + 1 }}</span>
            </div>
          </div>
          <div class="user-name">
            <div class="label-box">
              <span class="label-shadow">{{ item?.nickName }}</span>
              <span class="label-text">{{ item?.nickName }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="popularity">
        <i class="place"></i>
        <div class="label-box">
          <span class="label-shadow">
            <template v-if="showPrefix">贡献值 </template>{{ formatPopularity(item?.popularity) }}
          </span>
          <span class="label-text">
            <template v-if="showPrefix">贡献值 </template>{{ formatPopularity(item?.popularity) }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
defineProps({
  items: { type: Array, default: () => [] },
  size: { type: String, default: 'lg' },  // 'lg'(战队详情粉丝榜) | 'sm'(人气排行榜) | 'xs'(直播侧栏)
  defaultAvatar: { type: String, required: true },
  showPrefix: { type: Boolean, default: false }  // 显示 "贡献值 xxx" 前缀
})

function formatPopularity(p) {
  if (p == null) return 0
  return p >= 10000 ? (p / 10000).toFixed(2) + '万' : p
}
</script>

<style lang="scss" scoped>
.fan-top-three {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;

  .user-item {
    width: 32.12%;
    height: 100%;
    background: url(https://website.xdcdn.net/poster/58881/26match/common/QTaBf3yr.jpg) center/100% 100% no-repeat;
    @include r_shadow(0, 4, 4, rgba(#000, 0.1));

    .user-info {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      .user-img {
        flex: none;
        border-style: solid;
        border-color: #FFFFFF;
        background-position: center;
        background-repeat: no-repeat;
        background-size: cover;
      }
      .info-box {
        overflow: visible;
        .rank {
          font-weight: bold;
          font-family: NumFont;
          transform: skew(-6deg);
          line-height: 1.22;
          @include r(margin, -8, 0);
          .label-box {
            width: 100%;
            .label-shadow {
              color: #FFFFFF;
              -webkit-text-stroke-width: 0.12em;
            }
            .label-text {
              background-image: linear-gradient(180deg, #BE2B11 0%, #7C2408 100%);
              -webkit-background-clip: text;
              background-clip: text;
              -webkit-text-fill-color: transparent;
              color: transparent;
            }
          }
        }
        .user-name {
          display: flex;
          align-items: flex-start;
          .label-box {
            .label-shadow, .label-text {
              display: flex;
              max-width: 100%;
              overflow: hidden;
              line-height: 1;
              white-space: normal;
            }
            .label-shadow { color: #FFFFFF; }
            .label-text { color: #871714; }
          }
        }
      }
    }
    .popularity {
      box-sizing: border-box;
      position: relative;
      width: 90%;
      margin: 0 auto;
      display: flex;
      align-items: center;
      i.place {
        position: relative;
        flex-shrink: 0;
        background-position: center;
        background-repeat: no-repeat;
        background-size: contain;
        @include r(margin-right, 8);
      }
      .label-box {
        .label-shadow { color: #871714; }
        .label-text { color: #FFFFFF; }
      }
    }

    // rank-1 独特(切图 + 渐变 + place icon URL)
    &[data-rank="rank-1"] {
      background-image: url(https://website.xdcdn.net/poster/58881/26match/common/QTaAjhzv.jpg);
      .info-box .rank .label-box .label-text { background-image: linear-gradient(180deg, #DDA35D 0%, #BF8948 100%); }
      .info-box .user-name .label-box .label-text { color: #423824; }
      .popularity {
        i.place { background-image: url(https://website.xdcdn.net/poster/58881/26match/icon/QTbvh7yz.png); }
        .label-box {
          .label-shadow { color: #FFF6C2; }
          .label-text { color: #4C4C4C; }
        }
      }
    }
    &[data-rank="rank-2"] .popularity i.place {
      background-image: url(https://website.xdcdn.net/poster/58881/26match/icon/QTbvhgb1.png);
    }
    &[data-rank="rank-3"] .popularity i.place {
      background-image: url(https://website.xdcdn.net/poster/58881/26match/icon/QTbvhc31.png);
    }
  }

  // ------- 尺寸变体 -------
  &.size-lg {
    @include r(height, 224);
    .user-item {
      .user-info {
        @include r(padding, 12, 14, 0);
        @include r(margin-bottom, 24);
        .user-img {
          @include r(width, 130);
          @include r(height, 130);
          @include r(border-width, 4);
          @include r(margin-right, 19);
        }
        .info-box {
          @include r(width, 154);
          .rank {
            @include r(font-size, 76);
            @include r(height, 104);
            // TODO NO.1 视觉偏右 (skew 副作用), translateX 手动补偿
            transform: skew(-6deg) translateX(-10%);
          }
          .user-name {
            @include r(width, 180);
            @include r(font-size, 20);
            @include r(height, 24);
          }
        }
      }
      .popularity {
        @include r(height, 32);
        @include r(font-size, 20);
        i.place {
          @include r(width, 77);
          @include r(height, 63);
        }
        .label-box {
          @include r(margin-top, 8);
        }
      }
      &[data-rank="rank-2"] .popularity i.place { @include r(width, 67); }
      &[data-rank="rank-3"] .popularity i.place { @include r(width, 59); }
    }
  }

  &.size-sm {
    @include r(height, 165);
    .user-item {
      .user-info {
        @include r(padding, 11, 12, 0);
        @include r(margin-bottom, 20);
        .user-img {
          @include r(width, 94);
          @include r(height, 94);
          @include r(border-width, 3);
          @include r(margin-right, 4);
        }
        .info-box {
          @include r(width, 120);
          @include r(margin-top, -6);
          .rank {
            @include r(font-size, 56);
            @include r(margin-left, 0);
          }
          .user-name {
            @include r(font-size, 20);
            @include r(margin-left, 14);
            @include r(margin-top, 4);
          }
        }
      }
      .popularity {
        @include r(height, 25);
        @include r(font-size, 16);
        i.place {
          @include r(width, 63);
          @include r(height, 50);
          transform: translateY(-14%);
        }
      }
      &[data-rank="rank-2"] .popularity i.place { @include r(width, 58); }
      &[data-rank="rank-3"] .popularity i.place { @include r(width, 47); }
    }
  }

  // xs: 直播页侧栏 top3, 空间最紧凑
  &.size-xs {
    .user-item {
      @include r(width, 95);
      height: 100%;
      position: relative; // user-name absolute 定位祖先
      // TODO: 替换 xs 默认卡片背景 (lg/sm 用的是 QTaBf3yr.jpg)
      background-image: url(https://website.xdcdn.net/poster/58881/26match/common/Q3xX63hi.png);

      .user-info {
        @include r(padding, 5, 4, 0);
        @include r(margin-bottom, 23);
        .user-img {
          @include r(width, 38);
          @include r(height, 38);
          @include r(border-width, 1);
          @include r(margin-right, 3);
        }
        .info-box {
          @include r(width, 45);
          @include r(height, 40);
          .rank {
            @include r(font-size, 28);
            @include r(margin, 0);
          }
          // xs 布局: user-name 独占一行, absolute 挂到卡片内自定位置
          .user-name {
            position: absolute;
            display: flex;
            align-items: center;
            justify-content: center;
            @include r(top, 47);   // 头像下方 (头像 38 + 间距 4)
            @include r(left, 5);
            @include r(width, 87);
            @include r(font-size, 12);
            @include r(height, 20);
          }
        }
      }
      .popularity {
        @include r(margin-inline, 4);
        @include r(height, 28);
        @include r(font-size, 16);
        i.place {
          @include r(width, 22);
          @include r(height, 20);
          @include r(margin-right, 1);
        }
      }
      // TODO: 替换 xs 第一名卡片背景 (lg/sm 用的是 QTaAjhzv.jpg)
      &[data-rank="rank-1"] {
        background-image: url(https://website.xdcdn.net/poster/58881/26match/common/Q3xX6gs6.png);
      }
      &[data-rank="rank-2"] .popularity i.place { @include r(width, 20); }
      &[data-rank="rank-3"] .popularity i.place { @include r(width, 19); }
    }
  }
}
</style>
